export enum MessagingRouteName {
  ClientMessagesPage = 'client-messages-page',
}
